import { cn } from '@workspace/ui/lib/utils';
import React from 'react';

import type { Message, ToolCall } from '~/hooks/use-chat/types';

import { MessageContent } from './message-content';

type ChatMessageProps = {
  message: Message;
  handleAction: (action: ToolCall, response: string) => Promise<void>;
  isActive: boolean;
};

export const ChatMessage = React.memo(
  ({ message, handleAction, isActive }: ChatMessageProps) => {
    const isUserMessage = message.type === 'human' || message.type === 'tool';
    const isAIMessage = message.type === 'ai';

    return (
      <div
        className={cn('flex', {
          'justify-end': isUserMessage,
          'justify-start': isAIMessage,
        })}
      >
        <div
          className={cn(
            'rounded-2xl px-4 py-3 break-words text-sm font-normal bg-background text-muted-foreground',
            {
              'max-w-[70%]': isUserMessage,
              'w-full': isAIMessage,
            },
          )}
        >
          <div
            className={cn({
              'p-2 border rounded-md': isUserMessage,
            })}
          >
            <MessageContent
              message={message}
              handleAction={handleAction}
              isActive={isActive}
            />
          </div>
          {/* <div className="flex justify-between items-center mt-2">
            {message.type === 'human' && <span />}
            {!message?.tool_calls && <MessageActions role={message.role} />}
            <MessageTimestamp timestamp={message.timestamp} />}
          </div> */}
        </div>
      </div>
    );
  },
);
